import type { Task } from "@/types";

export const formatTime = (seconds: number): string => {
    const hrs = Math.floor(Math.abs(seconds) / 3600);
    const mins = Math.floor((Math.abs(seconds) % 3600) / 60);
    const secs = Math.abs(seconds) % 60;
    const sign = seconds < 0 ? "-" : "";
    if (hrs > 0) {
        return `${sign}${hrs}:${mins.toString().padStart(2, "0")}:${secs
            .toString()
            .padStart(2, "0")}`;
    }
    return `${sign}${mins}:${secs.toString().padStart(2, "0")}`;
};

export const formatHoursMinutes = (totalMinutes: number): string => {
    const hrs = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    if (hrs > 0) {
        return `${hrs}h ${mins}m`;
    }
    return `${mins}m`;
};

export const getDateKey = (date: Date): string => {
    return date.toISOString().split("T")[0];
};

export const isSameDay = (date1: Date, date2: Date): boolean => {
    return getDateKey(date1) === getDateKey(date2);
};

export const getElapsedSeconds = (task: Task): number => {
    if (task.status === "active" && task.activeStartedAt) {
        const now = new Date();
        const activeSeconds = Math.floor(
            (now.getTime() - task.activeStartedAt.getTime()) / 1000
        );
        return task.elapsedSeconds + activeSeconds;
    }
    return task.elapsedSeconds;
};

export const getRemainingSeconds = (task: Task): number => {
    const elapsed = getElapsedSeconds(task);
    return task.estimatedMinutes * 60 - elapsed;
};

export const isTaskOvertime = (task: Task): boolean => {
    return getRemainingSeconds(task) < 0;
};
